import { atom } from 'jotai/vanilla';
import type { EditingUser } from '@model-framework/text';

export interface EditingUsers {
  [key: string]: EditingUser;
}

export const editingUsersAtom = atom<EditingUsers>({});
